import * as React from 'react';
import CreatableSelect from 'react-select/lib/Creatable';
import classNames from 'classnames';

const components = {
  DropdownIndicator: null,
};

class MultiText extends React.Component {
    constructor(props) {
        super(props);

        let defaultValues = [];

        if (props.value) {
            defaultValues = props.value.map((x, i) => {
                return {
                    value: i,
                    label: x
                };
            });
        }

        this.state = {
            values: defaultValues,
            inputValue: '',
            invalid: false,
            index: (defaultValues && defaultValues.length && defaultValues.length - 1) || 0
        }
    }

    // Public
    setValue = (value) => {
        this.setState({ values: value });
    }

    getValue = () => {
        return this.state.values;
    }

    focus = () => {
        this._input.focus();
    }

    flag = (status) => {
        this.setState({ invalid: !status });
	}

	completed = () => {
		return !((this.state.values === null || this.state.values.length === 0) && this.props.required)
	}

    validate = () => {
        return null;
    }

    _handleOnChange = value => {
        this._update(value);
        this.props.onDirt && this.props.onDirt();
    }

    _isValidItem(value) {
        if (this.props.filter && !this.props.filter(value))
            return false;

        // Validate if the value is a number
        if (this.props.numbersOnly)
        {
            if (isNaN(value))
                return false

            var intVal = parseInt(value, 10);
            if (!Number.isInteger(intVal))
                return false;
        }

        return true;
    }

    _addNewItem() {
        const { inputValue, values } = this.state;

        if (!this._isValidItem(inputValue))
            return;

        let index = this.state.index;

        index++;

        this.setState({
            index: index,
            inputValue: '',
            values: [...values, { label: inputValue, value: index }],
        }, () => {
            this._handleOnChange(this.state.values);
        });
    }

    _handleKeyDown = (event) => {
        // Only allow numbers.
        if (this.props.numbersOnly) {
            if (!isFinite(event.key)
            && event.key !== 'Backspace'
            && event.key !== 'ArrowLeft'
            && event.key !== 'ArrowRight'
            && event.key !== 'Delete')
                event.preventDefault();
        }

        // Is separator being pressed? Don't write it.
        if (event.key === this.props.separator) {
            event.preventDefault();
        }

        const { inputValue } = this.state;

        if (!inputValue)
            return;

        switch (event.key) {
            case this.props.separator:
            case 'Enter':
            case 'Tab':
                this._addNewItem();
                event.preventDefault();
                break;
            default: break;
        }
    }

    _handleInputChange = (inputValue) => {
        if (this.props.maxLength && inputValue.length > this.props.maxLength)
            return;

        this.setState({ inputValue });
    }

    _handleInputFocus = (e) => {
        this.props.onFocus && this.props.onFocus();
    }

    _handleInputBlur = (e) => {
        if (!this.state.inputValue)
            return;

        this._addNewItem();
        this.props.onBlur && this.props.onBlur();
	}

    _update = (values) => {
		this.setState({ values: values }, () => {
			const validationResult = this.validate();
			const requiredPassed = this.completed();
			const validationPassed = (validationResult === null || validationResult === undefined);
			const status = requiredPassed && validationPassed;

            // Show error status if neccesary
			this.flag(status);

			// Trigger standard onChange...
			this.props.onChange && this.props.onChange(values.map(x => x.label));
			this.props.managed && this.props.onFieldChange(values.map(x => x.label), this.props.name);
		});
	}

    componentDidMount() {
        if (this.props.autoFocus)
            this.focus();
    }

    componentWillReceiveProps(props) {
        let defaultValues = [];

        if (props.value && props.value !== this.state.value) {
            defaultValues = props.value.map((x, i) => {
                return {
                    value: i,
                    label: x
                };
            });
        }

        this.setState({ values: defaultValues });
    }

    // React
    render() {
        const { inputValue, values } = this.state;

        const multiClass = classNames({
            "invalid-field": this.state.invalid
        });

        const props = {
            inputValue: inputValue,
            isClearable: true,
            isMulti: true,
            menuIsOpen: false,
            onFocus: this._handleInputFocus,
            onBlur: this._handleInputBlur,
            onChange: this._handleOnChange,
            onInputChange: this._handleInputChange,
            onKeyDown: this._handleKeyDown,
            placeholder: this.props.placeholder || "",
            isDisabled: this.props.disabled,
            value: values
        }

        const customStyles = {
			container: (base, state) => {
				if (!state.isDisabled) {
					return {
						...base,
						backgroundColor: "transparent",
					};
                } else {
					return {
						...base,
						backgroundColor: "#eee",
                    };
                 }
            },
			singleValue: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#555"
			}),
			placeholder: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#555"
			}),
			input: (provided, state) => ({
				...provided,
				marginTop: -2,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0,
                width: 100
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			indicatorsContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer'
			}),
			control: (provided, state) => ({
				...provided,
                minHeight: 34,
				boxShadow: 0,
				borderRadius: 0,
                borderColor: this.state.invalid ? "#a94442" : "hsl(0,0%,80%)"
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0,
				zIndex: "999 !important"
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			}),
			dropdownIndicator: (base, state) => ({
				...base,
				width: '30px',
                paddingTop: 0,
                paddingBottom: 0
			}),
			clearIndicator: (base, state) => ({
				...base,
				width: '30px',
                paddingTop: 0,
                paddingBottom: 0
			}),
			menuContainerStyle: () => ({
				zIndex: "999 !important"
			})
		}

        return (
            <CreatableSelect
                {...props}
                styles={customStyles}
                ref={s => this._input = s}
                components={components}
                className={multiClass} />
        );
    }
}

export default MultiText;

// Mark this as a form component
MultiText.defaultProps = {
    formControl: true,
    managed: false,
    maxLength: 64
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/multiText/MultiText.js